// @flow
import React from 'react';
import styled from 'styled-components';

import { row, column, grid, vspacer, hspacer } from '../utils/layout';
import type { ColumnWidth, ColumnOffset } from '../utils/layout';

type ColumnProps = {
  small?: ColumnWidth,
  medium?: ColumnWidth,
  large?: ColumnWidth,
  offsetSmall?: ColumnOffset,
  offsetMedium?: ColumnOffset,
  offsetLarge?: ColumnOffset,
};

const StyledColumn = styled.div`
  ${(props) =>
    column(
      props.small,
      props.medium,
      props.large,
      props.offsetSmall,
      props.offsetMedium,
      props.offsetLarge
    )};
`;

export const Column = (props: ColumnProps) => <StyledColumn {...props} />;
Column.displayName = 'Column';

export const Row = styled.div`
  ${row()};
`;
Row.displayName = 'Row';

export const Grid = styled.div`
  ${grid()};
`;
Grid.displayName = 'Grid';

type SpacerProps = {
  small?: number,
  medium?: number,
  large?: number,
};

const StyledVSpacer = styled.div`
  ${(props) => vspacer(props.small, props.medium, props.large)};
`;

const StyledHSpacer = styled.div`
  ${(props) => hspacer(props.small, props.medium, props.large)};
`;

export const Spacer = (props: SpacerProps) => <StyledVSpacer {...props} />;
export const VSpacer = (props: SpacerProps) => <StyledVSpacer {...props} />;
export const HSpacer = (props: SpacerProps) => <StyledHSpacer {...props} />;
